import { withInstall } from '@ll-plus/utils'

import VideoPlayer from './src/video-player.vue'

export const LlVideoPlayer = withInstall(VideoPlayer)

export * from './src/video-player'

declare module 'vue' {
  export interface GlobalComponents {
    LlVideoPlayer: typeof VideoPlayer
  }
}
